import { create } from "zustand";
import axios from "axios";
import Cookies from "js-cookie";

const orderReturnRequestStore = create((set) => ({
  orderReturnRequest: null,
  isLoading: false,

  createOrderReturnRequest: async ({ orderID, paymentID, whyReturn }) => {
    try {
      const res = await axios.post(
        "/site/create-order-return-request",
        {
          whyReturn,
          orderID,
          paymentID,
        }
      );

      const { orderReturnRequest } = orderReturnRequestStore.getState();
      const data = orderReturnRequest ? orderReturnRequest : [];
      data.push(res.data.orderReturnRequest);
      set({ orderReturnRequest: data });
    } catch (error) {
      console.log(error);
    }
  },

  fetchUserOrderReturnRequest: async () => {
    try {
      const res = await axios.get("/site/fetch-all-user-order-return-request");
      if (res.data.orderReturnRequest.length) {
        set({ orderReturnRequest: res.data.orderReturnRequest });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default orderReturnRequestStore;
